import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* Reset + box sizing */
  *,*::before,*::after{box-sizing:border-box}
  html,body,#root{height:100%}
  html {
    /* fluid type scale between 14px -> 18px */
    font-size: 14px;
  }
  @media(min-width:420px){ html{ font-size: 15px; } }
  @media(min-width:900px){ html{ font-size: 16px; } }
  @media(min-width:1400px){ html{ font-size: 17px; } }

  body{
    margin:0;
    background:${(p) => p.theme.colors.bg};
    color:${(p) => p.theme.colors.text};
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale;
    line-height:1.45;
    font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
    -webkit-font-feature-settings: "ss01" on;
  }

  a { color: inherit; }
  img { display:block; max-width:100%; height:auto; }

  /* Utility classes for spacing and layout */
  .container {
    width: 100%;
    margin: 0 auto;
    padding-left: 16px;
    padding-right: 16px;
  }
  @media(min-width:900px){
    .container { padding-left: 24px; padding-right: 24px; }
  }

  /* Focus outlines for keyboard users */
  :focus { outline: 3px solid rgba(11,100,209,0.18); outline-offset: 3px; }

  /* Simple image utility */
  .img-cover { width:100%; height:100%; object-fit:cover; display:block; }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      scroll-behavior: auto !important;
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyle;
